import React, { } from 'react'

import { Button } from '@material-ui/core'
import moment from 'moment'

const onPrem = Boolean(process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true')

export const toggleImage = (capture = {}, tempView = false, imgID = null, classStyle = {}, optHandlers = {}) => {
  const { redacted = false, signedUrlOrigin = '', signedUrl = '', quarantined = false } = capture

  const styleAttr = classStyle && typeof classStyle === 'string' ? { className: classStyle } : { style: { ...classStyle } }
  const imgAtts = { id: imgID || `img-${capture.violationID}`, src: '', ...styleAttr }

  if (quarantined && !redacted && !tempView) {
    imgAtts.src = `${require('../../assets/images/quarantine_1.png')}`
  } else {
    const displayImage = redacted && tempView ? signedUrlOrigin : signedUrl
    imgAtts.src = `${displayImage}${onPrem ? `?t=${moment().unix()}` : ''}`
  }

  return (
    <img alt='violation-capture-area' {...imgAtts} {...optHandlers} />
  )
}

export const toggleLocationName = (handleQuickFilter, capture, statusFlag) => {
  return (
    <Button
      variant='text'
      fullWidth
      color='primary'
      className='font-weight-bold'
      size='small'
      style={{ fontSize: '12px' }}
      onClick={(e) => { handleQuickFilter({ units: getLastUnit(capture) }) }}
    >
      {renderUnit(capture)}
    </Button>
  )
}

const renderUnit = (capture) => {
  const arr = capture.units.map((unit) => unit.unitName)
  return arr.join('/ ')
}

const getLastUnit = (capture) => {
  if (capture.units.length) {
    const unit = capture.units.pop()
    return [unit.unitID]
  } else {
    return []
  }
}
